/**
 * Eigen merk-DID's (digits-only E.164) — de nummers die wij als outbound
 * caller-ID gebruiken. Eén bron voor de frontend; houd in sync met
 * `api/_lib/phone-numbers.ts` (de volledige nummer→merk-map van de backend —
 * hier alleen de caller-ID-DID's, want daar matcht de bridge-heuristiek op).
 *
 * Gebruikt om te detecteren dat een "inbound" notificatie eigenlijk de
 * bridge-leg van onze eigen outbound dial is (auto-answer zonder UI-ring).
 */
export const OWN_DIDS_DIGITS = new Set<string>([
  '31850835120', // Kleda trunk-DID (Telnyx)
  '31882999299', // Cinco 088
  '31882999277', // Kleda 088
  '31850835546', // Schoonhuisshop 085
]);
